// extracted by mini-css-extract-plugin
module.exports = {"dg200TextA":"TextA_dg200TextA__UNdY4"};